import { isEmpty } from 'lodash';

import { escapeUnescapedQuotesAndBackslashes } from '@app/utils';

import { createBooleanChipQuery } from './parseMaskedAdvancedSearchQuery';
import {
  FieldQualifierValue,
  getCqlFieldQualifierValue,
} from './getCqlFieldQualifierValue';
import {
  fieldsToMaskMap,
  FormValues,
  searchQualifierMaskMap,
} from '../constants';

const createAdvancedSearchQuery = ({
  searchRows,
  getQuery,
  shouldEscape = false,
}: {
  searchRows: FormValues;
  getQuery: (value: FieldQualifierValue) => string;
  shouldEscape?: boolean;
}) =>
  Object.values(searchRows).reduce((queryString, row) => {
    const { booleanChip } = row;
    const shouldPrependChip =
      !isEmpty(queryString) && booleanChip !== undefined;
    const chipQuery = shouldPrependChip
      ? createBooleanChipQuery(booleanChip)
      : '';

    const currentRowString = row.value
      ? `${chipQuery}${getQuery({
          field: row.field,
          qualifier: row.qualifier,
          value: shouldEscape
            ? escapeUnescapedQuotesAndBackslashes(row.value)
            : row.value,
        })}`
      : '';

    return `${queryString}${currentRowString}`;
  }, '');

const getMaskedQuery = ({ field, qualifier, value }: FieldQualifierValue) =>
  `${fieldsToMaskMap[field]} ${searchQualifierMaskMap[qualifier]} "${value}"`;

export const createMaskedAdvancedSearchQuery = (searchRows: FormValues) =>
  createAdvancedSearchQuery({ searchRows, getQuery: getMaskedQuery });

export const createCqlAdvancedSearchQuery = (searchRows: FormValues) =>
  createAdvancedSearchQuery({
    searchRows,
    getQuery: getCqlFieldQualifierValue,
    shouldEscape: true,
  });
